<p-button  [label]="label" [type]="type" [ngClass]="styleClass" (click)="buttonClick()" [severity]="severity" [size]="size" [disabled]="disabled">
  @if (saving()) {
    <p-progress-spinner  styleClass="custom-spinner flex items-center" ></p-progress-spinner>
  }
  @if (!saving()) {
    <ng-content select="[icon]"></ng-content>
  }
  <ng-content></ng-content>
</p-button>
